import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Card } from '@mui/material';
import PropTypes from 'prop-types';
import { useVerifyDiscountCode } from '../../hooks/useDiscountCode';
import { REFERRAL_CODE_KEY } from '../../constants';
import { LoadingIndicator, SubTitle, PageTitle, When } from '../common';
import { ACCOUNT, ACCOUNT_SUBSCRIBE } from '../../constants/routePaths';
import { ReferralCodeMessages } from '../../constants/errorMessages';
import useUser from '../../hooks/useUser';
import { TRIAL, TRIAL_ENDED } from '../../constants/accountStatuses';

const ReferralBox = ({ title, subtitle, onClick, buttonText }) => (
  <Box display="flex" flexDirection="column" alignItems="center">
    <PageTitle>{title}</PageTitle>
    {subtitle && <SubTitle>{subtitle}</SubTitle>}
    <Button onClick={onClick} variant="outlined" style={{ padding: '0 3em', marginTop: '1em' }}>
      {buttonText}
    </Button>
  </Box>
);

const ReferralCodeCheck = () => {
  const history = useHistory();
  const { mutate: verifyCode, isSuccess, isError, isLoading, error } = useVerifyDiscountCode();
  const { user, isLoading: userLoading } = useUser();
  const validUser = (!userLoading && user?.status === TRIAL) || user?.status === TRIAL_ENDED;
  const referralCode = localStorage.getItem(REFERRAL_CODE_KEY);
  if (!referralCode) history.replace(ACCOUNT);

  useEffect(() => {
    if (referralCode && validUser) {
      verifyCode(referralCode);
    }

    // this effect should only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <When it={!validUser}>
          <ReferralBox
            title={ReferralCodeMessages.FirstTimeSubscriber}
            onClick={() => {
              history.replace(ACCOUNT);
              localStorage.removeItem(REFERRAL_CODE_KEY);
            }}
            buttonText="OK"
          />
        </When>

        <When it={isLoading}>
          <SubTitle>Applying Referral Code</SubTitle>
          <LoadingIndicator />
        </When>

        <When it={isSuccess}>
          <ReferralBox
            title={ReferralCodeMessages.Success}
            subtitle={ReferralCodeMessages.SuccessSubtitle}
            onClick={() => {
              history.replace(ACCOUNT_SUBSCRIBE);
              localStorage.removeItem(REFERRAL_CODE_KEY);
            }}
            buttonText="OK"
          />
        </When>

        <When it={isError}>
          <ReferralBox
            title={
              ReferralCodeMessages[error?.response?.data?.errors[0]?.code] ||
              ReferralCodeMessages.General
            }
            onClick={() => {
              history.replace(ACCOUNT);
              localStorage.removeItem(REFERRAL_CODE_KEY);
            }}
            buttonText="OK"
          />
        </When>
      </Card>
    </>
  );
};

ReferralBox.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};

ReferralBox.defaultProps = {
  subtitle: null,
};

export default ReferralCodeCheck;
